<template>
    <div class="h-90">
        <div class="is-inline-flex has-text-primary w-100 pl-1 pt-1">
            <h6 class="is-subtitle-size is-primary pl-3 mr-4">
                {{ $t("conference.whiteboard") }}
            </h6>
            <img
                src="@/assets/icons/userPizzarraAZ.svg"
                width="23"
                height="25"
            />
        </div>
        <div class="h-100">
            <div class="columns">
                <div v-if="!somethingIsSharing" class="column is-narrow">
                    <div class="is-block pl-2 mt-4">
                        <template v-for="(action, index) in actions">
                            <ActionItem :action="action" :key="index" />
                        </template>
                    </div>
                </div>
                <div class="column" v-if="fileId">
                    <PdfViewer
                        :fileId="fileId"
                        :signalRSocket="signalRSocket"
                    />
                </div>
                <div class="column" v-if="surveyId">
                    <SurveyLoader :surveyId="surveyId" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import PdfViewer from "./pdf/PdfViewer";
import ActionItem from "./actions/actions-list/ActionItem";
import SurveyLoader from "@/components/external-components/survey-viewer/SurveyLoader.vue";

export default {
    components: { PdfViewer, ActionItem, SurveyLoader },
    name: "colaborative-board",
    props: {
        signalRSocket: { type: Object, required: true },
    },
    computed: {
        ...mapGetters("colaborativeBoard", ["getFileId", "getSurveyId"]),
        ...mapGetters("actions", ["getActions"]),
        isSharingDocument() {
            return this.getFileId !== null;
        },
        fileId() {
            return this.getFileId;
        },
        actions() {
            return this.getActions;
        },
        isSharingSurvey() {
            return this.getSurveyId !== null;
        },
        surveyId() {
            return this.getSurveyId;
        },
        somethingIsSharing() {
            return this.isSharingDocument | this.isSharingSurvey;
        },
    },
};
</script>